import { authQueries } from '@/api/common/auth';
import { useAuth } from '@clerk/react';
import { useQuery } from '@tanstack/react-query';

export const useWhoAmI = () => {
  const { isSignedIn } = useAuth();

  return useQuery({
    ...authQueries.whoAmI(),
    enabled: !!isSignedIn
  });
};
